'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _startCase2 = require('lodash/startCase');

var _startCase3 = _interopRequireDefault(_startCase2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var formatDuration = _utils.FormattingUtils.formatDuration,
    formatDurationInMonthsOrDays = _utils.FormattingUtils.formatDurationInMonthsOrDays,
    getOrDefault = _utils.FormattingUtils.getOrDefault;

var TermsTableRow = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(TermsTableRow, _Component);

  function TermsTableRow() {
    _classCallCheck(this, TermsTableRow);

    return _possibleConstructorReturn(this, (TermsTableRow.__proto__ || Object.getPrototypeOf(TermsTableRow)).apply(this, arguments));
  }

  _createClass(TermsTableRow, [{
    key: 'onChange',
    value: function onChange(event) {
      this.props.onChange(this.props.id, event.target.value);
    }
  }, {
    key: 'durationText',
    value: function durationText() {
      var _props = this.props,
          id = _props.id,
          length = _props.length,
          duration = _props.term.duration;


      if (id === length - 1 && duration === null) {
        return 'Uncapped';
      }

      var durationFormatted = formatDurationInMonthsOrDays(duration);
      var prefix = void 0;
      if (id === 0) {
        prefix = 'First';
      } else if (id === length - 1) {
        prefix = 'Last';
      } else {
        prefix = 'Next';
      }

      return prefix + ' ' + durationFormatted;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          isInvalid = _props2.isInvalid,
          locked = _props2.locked,
          max = _props2.max,
          min = _props2.min,
          _props2$term = _props2.term,
          schedule_bucket_duration = _props2$term.schedule_bucket_duration,
          interest_accrual_duration = _props2$term.interest_accrual_duration,
          interest_rate = _props2$term.interest_rate,
          interest_type = _props2$term.interest_type,
          interestRateText = formatDuration(interest_accrual_duration),
          interestTypeText = (0, _startCase3.default)(interest_type).toLowerCase(),
          scheduleBucketText = getOrDefault(formatDurationInMonthsOrDays(schedule_bucket_duration));


      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          this.durationText()
        ),
        _react2.default.createElement(
          'td',
          { className: 'col-interest-rate' + (isInvalid ? ' has-error' : '') },
          locked ? interest_rate : _react2.default.createElement('input', {
            max: max,
            min: min,
            name: 'rate',
            onChange: this.onChange,
            step: 0.1,
            type: 'number',
            value: interest_rate
          }),
          '% every ',
          interestRateText,
          ', ',
          interestTypeText
        ),
        _react2.default.createElement(
          'td',
          { className: 'text-right' },
          scheduleBucketText
        )
      );
    }

    // max, min and isInvalid carry the rate band a loan template sets; liens have none

  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return TermsTableRow;
}(_react.Component), _class2.propTypes = {
  id: _propTypes2.default.number.isRequired,
  isInvalid: _propTypes2.default.bool,
  length: _propTypes2.default.number.isRequired,
  locked: _propTypes2.default.bool.isRequired,
  max: _propTypes2.default.number,
  min: _propTypes2.default.number,
  onChange: _propTypes2.default.func.isRequired,
  term: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class;

var _default = TermsTableRow;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(formatDuration, 'formatDuration', '/app/src/components/page-case/TermsTableRow.js');
  reactHotLoader.register(formatDurationInMonthsOrDays, 'formatDurationInMonthsOrDays', '/app/src/components/page-case/TermsTableRow.js');
  reactHotLoader.register(getOrDefault, 'getOrDefault', '/app/src/components/page-case/TermsTableRow.js');
  reactHotLoader.register(TermsTableRow, 'TermsTableRow', '/app/src/components/page-case/TermsTableRow.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/TermsTableRow.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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